import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useDispatch } from 'react-redux'
import {
	Backdrop,
	Box,
	Button,
	Card,
	Divider,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
	useMediaQuery,
} from '@mui/material'
import { mainGreen, mainRed } from '../../utils/color'
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { DOMAIN } from '../../utils/api'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import { getFromStorage } from '../../utils/storage'

export default function BillDetail() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const [billDetail, setBillDetail] = useState([])
	const [loader, setLoader] = useState(false)
	const { billCode } = useParams()
	const [showBackdrop, setShowBackdrop] = useState(false)
	const [disabled, setDisabled] = useState(false)
	const [fileUpload, setFileUpload] = useState([])
	const [preview, setPreview] = useState([])

	useEffect(() => {
		if (!fileUpload) {
			setPreview(undefined)
			return
		}
		let preview = []
		for (let i = 0; i < fileUpload.length; i++) {
			preview.push(URL.createObjectURL(fileUpload[i]))
		}
		setPreview(preview)
	}, [fileUpload])

	const onFileChange = async (e) => {
		setFileUpload(e.target.files)
	}

	const getBillDetail = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/stock/bill-detail/${billCode}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setBillDetail(response.data)
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, billCode],
	)

	useEffect(() => {
		getBillDetail()
	}, [getBillDetail])

	const saveBill = async (e, action) => {
		e.preventDefault()
		setDisabled(true)
		try {
			const formData = new FormData()
			for (let i = 0; i < fileUpload.length; i++) {
				formData.append('image', fileUpload[i])
			}

			const response = await axios({
				url: `${DOMAIN}/stock/save-bill/${billCode}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				},
				data: formData,
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			getBillDetail()
			setShowBackdrop(false)
			setDisabled(false)
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const downloadPDF = async () => {
		try {
			const capture = document.querySelector('.actual-receipt')
			setLoader(true)
			html2canvas(capture, { scale: 5 }).then((canvas) => {
				const imgData = canvas.toDataURL('image/jpeg')
				const doc = new jsPDF({
					orientation: 'portrait',
					unit: 'px',
					format: 'a4',
				})
				const componentWidth = doc.internal.pageSize.getWidth()
				const componentHeight = (canvas.height * componentWidth) / canvas.width
				doc.addImage(imgData, 'JPEG', 0, 0, componentWidth, componentHeight)
				setLoader(false)
				doc.save('Hoa-don-NNQQ.pdf')
			})
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 700,
					marginX: 'auto',
					pb: 4,
					background: '#fff',
				}}>
				<Backdrop
					sx={{
						color: '#fff',
						zIndex: (theme) => theme.zIndex.drawer + 1,
						left: mediaMd ? 300 : 0,
					}}
					open={showBackdrop}>
					<Card
						sx={{ padding: '10px 20px', width: '280px' }}
						onClick={(e) => {
							e.stopPropagation()
						}}>
						<Typography
							sx={{
								textAlign: 'center',
								fontSize: '18px',
								fontWeight: 'bold',
								mb: 1,
							}}>
							Hình xác nhận
						</Typography>
						<>
							<Box sx={{ mt: 2 }}>
								{preview?.map((img, index) => {
									return (
										<img
											loading='lazy'
											key={index}
											style={{
												width: 50,
												marginRight: '8px',
											}}
											src={img}
											alt='preview'
										/>
									)
								})}
								<Box>
									<IconButton sx={{ padding: '0' }}>
										<label htmlFor='choose-photo-confirm-bill' style={{ display: 'flex', cursor: 'pointer' }}>
											<AddPhotoAlternateRoundedIcon sx={{ color: mainGreen }} />
										</label>
									</IconButton>
									<input
										multiple
										accept='image/*'
										onChange={onFileChange}
										id='choose-photo-confirm-bill'
										type='file'
										style={{ display: 'none' }}
									/>
								</Box>
							</Box>
							<Box display='flex' justifyContent='space-between'>
								<Button
									disabled={disabled}
									sx={{
										mt: 2,
										width: '75%',
										mr: 1,
										background: mainGreen,
										'&:hover': { background: mainGreen },
									}}
									size='small'
									variant='contained'
									onClick={saveBill}>
									Xác nhận
								</Button>
								<Button
									sx={{
										mt: 2,
										background: mainRed,
										'&:hover': { background: mainRed },
									}}
									variant='contained'
									size='small'
									onClick={() => {
										setShowBackdrop(false)
										setFileUpload([])
									}}>
									Hủy
								</Button>
							</Box>
						</>
					</Card>
				</Backdrop>
				<Box className='actual-receipt' sx={{ px: 1, pt: 4 }}>
					<Typography
						sx={{
							fontSize: '18px',
							fontWeight: 'bold',
							textAlign: 'center',
							letterSpacing: '2px',
							mb: 2,
						}}>
						HÓA ĐƠN BÁN HÀNG <br />
						CHI NHÁNH {billDetail[0]?.request?.store?.name}
						{billDetail[0]?.payment === 'paid' && (
							<Typography sx={{ color: mainGreen, fontWeight: 'bold' }}>( Đã thanh toán )</Typography>
						)}
					</Typography>
					<Box>
						<Typography>Mã HĐ: {billCode}</Typography>
						<Typography>Ngày xuất: {billDetail[0]?.billTimeStamp?.slice(0, 8)}</Typography>
						<Table sx={{ mt: 2 }}>
							<TableHead>
								<TableRow>
									<TableCell
										sx={{
											px: 0,
											py: 1,
											borderRight: '1px solid #000',
										}}>
										STT
									</TableCell>
									<TableCell
										sx={{
											px: 0,
											py: 1,
											borderRight: '1px solid #000',
										}}>
										Ngày giao
									</TableCell>
									<TableCell
										sx={{
											px: 0,
											py: 1,
											borderRight: '1px solid #000',
										}}>
										Số kg
									</TableCell>
									<TableCell
										sx={{
											px: 0,
											py: 1,
											borderRight: '1px solid #000',
										}}>
										Thực tính
									</TableCell>
									<TableCell
										sx={{
											px: 0,
											py: 1,
											borderRight: '1px solid #000',
										}}>
										Đơn giá
									</TableCell>
									<TableCell sx={{ px: 0, py: 1 }}>Thành tiền</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{billDetail?.map((item, index) => {
									return (
										<TableRow key={index}>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>{index + 1}</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>{item.timeStamp.slice(0, 8)}</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>
												{item.quantity?.toLocaleString()}
											</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>
												{Math.round(item.quantity * 0.98)?.toLocaleString()}
											</TableCell>
											<TableCell sx={{ p: 1, borderRight: '1px solid #000' }}>
												{item.unitPrice?.toLocaleString()}
											</TableCell>
											<TableCell sx={{ p: 1 }}>
												{(Math.round(item.quantity * 0.98) * item.unitPrice)?.toLocaleString()}
											</TableCell>
										</TableRow>
									)
								})}
							</TableBody>
						</Table>
						<Divider sx={{ mt: 2, mb: 2 }} />
						<Box display='flex' justifyContent='space-between' sx={{ mb: 1 }}>
							<Typography sx={{ fontWeight: '500' }}>Tổng số kg:</Typography>
							<Typography sx={{ fontWeight: '500' }}>
								{billDetail?.reduce((sum, item) => (sum += item.quantity), 0)?.toLocaleString()} (Thực tính:{' '}
								{billDetail?.reduce((sum, item) => (sum += Math.round(item.quantity * 0.98)), 0)?.toLocaleString()})
							</Typography>
						</Box>
						<Box display='flex' justifyContent='space-between' sx={{ mb: 4 }}>
							<Typography sx={{ fontWeight: '500' }}>Tổng tiền:</Typography>
							<Typography sx={{ fontWeight: '500' }}>
								{billDetail
									?.reduce((sum, item) => (sum += Math.round(item.quantity * 0.98) * item.unitPrice), 0)
									?.toLocaleString()}{' '}
								đ
							</Typography>
						</Box>
					</Box>
				</Box>
				<Box display='flex' justifyContent='space-between' alignItems='flex-end' sx={{ px: 1 }}>
					{billDetail[0]?.payment !== 'paid' && (
						<Button
							size='small'
							sx={{
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							variant='contained'
							onClick={() => {
								setShowBackdrop(true)
							}}>
							Xác nhận
						</Button>
					)}
					<div></div>
					<Button size='small' sx={{ color: mainRed }} onClick={downloadPDF} disabled={!(loader === false)}>
						<SaveAltOutlinedIcon sx={{ fontSize: '22px', mt: '-6px', mr: 1 }} />
						{loader ? 'Đang tải' : 'Tải PDF'}
					</Button>
				</Box>
			</Box>
		</UserLayout>
	)
}
